<template>
  <section class="newsletter-section" id="newsletter">
    <div class="newsletter-container">
      <!-- Left Image Section -->
      <div class="newsletter-image">
        <img
          src="@/assets/images/home/hero1.jpg"
          alt="Firefighters"
          class="img-fluid"
        />
      </div>

      <!-- Right Form Section -->
      <div class="newsletter-form">
        <h2>Contact Us</h2>
        <form @submit.prevent="subscribe">
          <input v-model="name" type="text" placeholder="Name" required />
          <input v-model="email" type="email" placeholder="Email" required />
            <input v-model="mobile" type="tel" placeholder="Mobile" required />
            <input
              v-model="occupation"
              type="text"
              placeholder="Occupation"
              required
            />
          <button type="submit">Let’s join the family</button>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "NewsletterSection",
  data() {
    return {
      name: "",
      email: "",
      mobile: "",
      occupation: "",
    };
  },
  methods: {
    subscribe() {
      alert(
        `Subscribed with: ${this.name}, ${this.email}, ${this.mobile}, ${this.occupation}`
      );
    },
  },
};
</script>

<style scoped>


.newsletter-container {
  display: flex;
  width: 100vw; /* Responsive width for the entire section */
  height: 60vh; /* Full view height */

}

.newsletter-image {
  width: 50%;
}

.newsletter-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.newsletter-form {
  width: 50%;
  background-color: #f0f0f0; /* Bright yellow for form background */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px;
}

.newsletter-form h2 {
  color: black;
  margin-bottom: 30px;
  font-size: 36px;
}

form {
  display: flex;
  flex-direction: column;
  width: 100%;
}

input {
  width: 100%;
  padding: 15px;
  margin-bottom: 15px;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
}

.row {
  display: flex;
  gap: 10px;
}

.row input {
  width: 100%;
}

button {
  background-color: #424242; /* Dark color for the button */
  color: white;
  padding: 15px;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  width: 100%;
}

button:hover {
  background-color: #333; /* Darker on hover */
}
</style>
